import {
  getNameDescriptionTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'name',
        title: i18n.t('scope.text_487'),
        edit: false,
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      {
        field: 'currency',
        title: i18n.t('scope.text_420'),
        minWidth: 70,
      },
      {
        field: 'project_domain',
        title: i18n.t('scope.text_421'),
        minWidth: 70,
      },
      {
        title: i18n.t('scope.text_488'),
        field: 'billing_cycle',
        minWidth: 70,
        formatter: ({ row, cellValue }) => {
          const val = cellValue.substr(0, cellValue.length - 1)
          const obj = {
            D: i18n.t('scope.text_489'),
            M: i18n.t('scope.text_490'),
            Y: i18n.t('scope.text_491'),
          }
          return val + obj[cellValue.charAt(cellValue.length - 1)]
        },
      },
      {
        field: 'grace_period',
        title: i18n.t('scope.text_492'),
        minWidth: 70,
        formatter: ({ row, cellValue }) => {
          const val = cellValue.substr(0, cellValue.length - 1)
          const obj = {
            D: i18n.t('scope.text_489'),
            M: i18n.t('scope.text_490'),
            Y: i18n.t('scope.text_491'),
          }
          return val + obj[cellValue.charAt(cellValue.length - 1)]
        },
      },
      {
        field: 'time_zone',
        title: i18n.t('scope.text_493'),
        minWidth: 100,
      },
      {
        title: i18n.t('scope.text_426'),
        field: 'status',
        minWidth: 70,
        formatter: ({ cellValue }) => {
          const obj = {
            init: i18n.t('scope.text_427'),
            active: i18n.t('scope.text_428'),
            cancelled: i18n.t('scope.text_456'),
          }
          return obj[cellValue]
        },
      },
    ]
  },
}
